"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const dropdown_1 = require("components/cosmos/v2/dropdown");
const moreOptionsButton_1 = __importDefault(require("components/moreOptionsButton"));
const translationContext_1 = require("configs/translationContext");
const mobx_react_1 = require("mobx-react");
const mapStateToProps = (stores) => ({
    isMobile: stores.UiStore.isMobile
});
const DrippingActions = ({ isMobile, onEditClick, onRemoveClick }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(dropdown_1.Dropdown, { docked: isMobile, children: [(0, jsx_runtime_1.jsx)(moreOptionsButton_1.default, { label: t('general.view_more'), onClick: (event) => event.stopPropagation() }), (0, jsx_runtime_1.jsxs)(dropdown_1.Dropdown.Menu, { children: [(0, jsx_runtime_1.jsx)(dropdown_1.Dropdown.MenuItem, { role: "button", icon: ['fal', 'pencil'], onClick: onEditClick, children: t('dripping_2.actions.edit') }), (0, jsx_runtime_1.jsx)(dropdown_1.Dropdown.MenuItem, { role: "button", icon: ['fal', 'trash'], className: "_text-red-dark", onClick: onRemoveClick, children: t('general.exclude') })] })] }));
};
exports.default = (0, mobx_react_1.inject)(mapStateToProps)(DrippingActions);
